/**
 * Receives an object with multiple financial attributes
 * @param {object} simulationParams object that contains all the financial info to be processed
 * @returns void
 * @author Lorena Carla & Rafael Almeida
 *Função construída com base nesse link https://docs.google.com/spreadsheets/d/16UB1nA3q0cIVjPAiixbcfsyEH6jVGDoBgBr72PM_JcA/edit#gid=570674978
 *
 */

import { alternativeFormater } from 'utils/formatNumber'

const SimulateValues = simulationParams => {
  const {
    priceValue,
    entryValue,
    monthlyInterestValue,
    installmentsValue,
    setterFirstInstallment,
    setterLastInstallment,
  } = simulationParams
  if (!entryValue) {
    setterFirstInstallment('first_parcel_amount', null)
    setterLastInstallment('last_parcel_amount', null)

    return
  }

  let debitBalance = priceValue - entryValue
  const minInstallmentsValue = 12
  for (let i = 12; i <= installmentsValue; i += 12) {
    const taxaDeReajuste = 1
    let currentInstallment = 0

    if (i === minInstallmentsValue) {
      currentInstallment =
        debitBalance * (monthlyInterestValue / 100 + 1 / installmentsValue)
      setterFirstInstallment(
        'first_parcel_amount',
        alternativeFormater(currentInstallment.toFixed(2))
      )
      setterLastInstallment(
        'last_parcel_amount',
        alternativeFormater(currentInstallment.toFixed(2))
      )
    } else if (installmentsValue !== 12) {
      currentInstallment =
        debitBalance *
        (monthlyInterestValue / 100 + 1 / (installmentsValue - (i - 12)))
      if (i === Number(installmentsValue)) {
        setterLastInstallment(
          'last_parcel_amount',
          alternativeFormater(currentInstallment.toFixed(2))
        )
      }
    }
    let totalMonthlyInterest = 0
    for (let j = 0; j < 12; j += 1) {
      totalMonthlyInterest =
        (monthlyInterestValue / 100) * (debitBalance * taxaDeReajuste)
      debitBalance -= currentInstallment - totalMonthlyInterest
    }
  }
}

export default SimulateValues
